import React from 'react';
import {useSelector} from 'react-redux';
import CleverTap from 'clevertap-web-sdk';
import {getItemOfSessionStorage} from "../services/common/utils";
import dayjs from 'dayjs';
import {SELECTED_LANG, AUTH_KEY} from "../services/common/Constants";
import { useTranslation } from 'react-i18next';


export const CT_Events = () =>{
    const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
    const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
    const data = JSON.parse(getItemOfSessionStorage("currentPage"));
    const language = getItemOfSessionStorage(SELECTED_LANG);
    const date  = new Date();
    const primaryNumber = useSelector((state) => state?.userdata?.value?.NojoomPrimaryNumber);
    const { t } = useTranslation();
    const getId = (list, type) => {
        if(type === "NojoomEarnPoints" || type === "nojoomPartners" || type === "nojoomPartner" || type === "transferPoints" || type === "OoredeoRewards" || type === "ooredoRewardsList" || type === "NojoomPartner" || type === "GTL" || type === "TransferPoints" || type === "OoredeoRewardsDetails" || type === "Nojoom_Partner" || type === "OoredeooServices" || type === "DigitalServices") return list?.id;
        else if(type === "NojoomPay") return list?.memberid;
        else return list?.offerid
    }
    const getItemName = (list, type) =>{
        if(type === "SpecialDeals_Postpaid" || type === "DigitalServices" || type=== "NojoomEarnPoints" || type === "nojoomPartners" || type === "nojoomPartner" || type === "transferPoints" || type === "OoredeoRewards" || type === "NojoomPartner" || type === "OoredeoRewardsDetails" || type === "Nojoom_Partner" || type === "DigitalService") return list?.name;
        else if(type === "addons" || type === "SpecialDeals_Prepaid" || type === "bundles" || type === "roamingDeals" || type === "ooredoRewardsList" || type === "RoamingMultiContries" || type === "RoamingCountries" || type === "GTL" || type === "addonDetails" || type=== "SpecialDealsPrePaid" || type === "recentpurchase" || type === "addon" || type === "OoredeooServices" || type === "roaming" || type === "RecentTransaction" ) return list?.title;
        else if(type === "NojoomHotDeals") return "Nojoom Hot Deals"
        else if(type === "TransferPoints") return list?.displaytext ;
    }
    const getPrice = (list, type) =>{
        if(type === "SpecialDeals_Postpaid" || type === "SpecialDeals_Prepaid" || type === "NojoomPartner" || type === "GTL" || type === "NojoomHotDeals" || type === "TransferPoints" || type === "OoredeoRewardsDetails" || type === "SpecialDealsPrePaid" ) return list?.amount;
        else if(type === "DigitalServices" || type === "NojoomEarnPoints" || type === "nojoomPartners" || type === "transferPoints" || type === "OoredeoRewards" || type === "ooredoRewardsList") return list?.price;
        else if(type === "addons" || type === "bundles" || type=== "roamingDeals" || type === "RoamingMultiContries" || type === "addonDetails" || type === "recentpurchase" || type === "addon" || type === "DigitalService" || type === "roaming" || type === "RecentTransaction" ) return list?.offerbaseprice;
        else if(type === "nojoomPartner" || type === "RoamingCountries") return list?.dofferbaseprice;
        else if(type === "Nojoom_Partner" ) return list?.title?.slice(0,4);
        else if(type === "OoredeooServices" ) return list?.points + "points"
    }
    const getCategory = (list, type) =>{
        if(type === "SpecialDeals_Postpaid" || type === "DigitalServices" || type === "SpecialDeals_Prepaid" || type === "nojoomPartners" || type === "nojoomPartner" || type === "transferPoints"  || type === "NojoomEarnPoints" || type === "NojoomPartner" || type === "GTL" || type === "NojoomHotDeals" || type === "addonDetails" || type === "OoredeoRewardsDetails" || type === "DigitalService" || type === "RecentTransaction") return list?.category;
        else if(type === "addons" || type === "bundles"  || type === "roamingDeals"  || type === "recentpurchase" || type === "roaming" ) return list?.offercategory;
        else if(type === "OoredeoRewards" || type === "ooredoRewardsList") return list?.type;
        else if(type === "RoamingCountries" || type === "RoamingMultiContries" ) return list?.eventlog_catg;
        else if(type === "SpecialDealsPrePaid" || type === "Nojoom_Partner" || type === "OoredeooServices" ) return type
        else if(type === "addon") return list?.paymenttype
    }
  
    const CT_ScreenView = (screenName='') =>{
        return CleverTap.event.push('screenview', {
            screen_name: screenName ? screenName : JSON.parse(getItemOfSessionStorage("currentPage")).pagename,
            LoginType: logintype || '',
            Status: 'Success',
            'Mobile Number':msisdn || '',
            'Status Description': 'Success',
        });
    }

    const CT_SignUp = (logintype, email, signUpNumber) =>{
        return CleverTap.event.push("Signup", {
            "LoginType": logintype || '',
            "SSO Details": email || '',                                  //?
            "Status": getItemOfSessionStorage(AUTH_KEY) ? "Success" : "Failure",
            "Status Description": getItemOfSessionStorage("loginStatus"),
            "Registered On": dayjs(date).format("DD-MM-YYYY hh:mm A"),
            "Channel" : "WEB",                                  
            "Mobile Number" : signUpNumber,
            "Language" : language
        })
    }

    const CT_OtpVerification = (mobileNumber) =>{
        return CleverTap.event.push("OTPVerification", {
            "screen name": data.pagename,
            "Mobile Number": mobileNumber,
            "Channel": "WEB"
        })
    }

    const CT_BalanceTransfer = (B_party, amount, status, statusDesc) =>{
        return CleverTap.event.push("Balance Transfer", {
            "Mobile Number": msisdn,
            "B Party": B_party,
            "Amount": amount + t('kd'),
            "Status": status,
            "Status Description" : statusDesc,
            "Login Type": logintype
        })
    }

    const CT_Logout = () =>{
        return CleverTap.event.push("logout", {
            "SSO": '', //?
            "Status": "Success",
            "Status Description": "User logged out successfully",
            "Channel": 'WEB'
        })
    }

    const CT_MoreDetails =(Action) =>{
        return CleverTap.event.push("MoreDetails",{
            "Mobile Number": msisdn,
            "Status": "Success",
            "Status Description": "",
            "Channel": "Web",
            "Action": Action
        })
    } 

    const CT_ChangeLanguage = (Language) =>{
        return CleverTap.event.push("ChangeLanguage", {
            "Mobile Number": msisdn,
            "Language": Language,
            "Status": "Success",
            "Status Description": "Launguage changed successfully",
            "Channel": "WEB"
        })
    }

    const CT_ChangeNumber = (loggedMsisdn) =>{
        return CleverTap.event.push("ChangeNumber",{
            "Logged Mobile Number": loggedMsisdn,
            "Changed Mobile Number": msisdn,
            "Status": "Success",
            "Status Description": "Mobile number changed successfully"
        })
    }

    const CT_UserProfilePlan = (Desc) =>{
        return CleverTap.event.push("UserProfilePlan",{
            "Mobile Number": msisdn,
            "Status": "Success",
            "Status Description": Desc,
            "PlanName":JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",
            "Plan ID": JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        })
    }
    const CT_InternetTransfer = (action, price, status, statusDesc, memberNumber, Donar, title, id) =>{
        return CleverTap.event.push("InternetTransfer",{
            "Action": action,
            "OfferName": title,
            "OfferID": id,
            "Price": price,
            "Status": status,
            "StatusDescription": statusDesc,
            "MemberNumber": memberNumber,
            "DonarNumber": Donar,
            "DateTime": dayjs(date).format("DD-MM-YYYY hh:mm A"),
            "LoggedInNumber": msisdn,
            "LoginType": logintype
        })
    }

    const CT_DeleteAccount = (profile, status, statusDesc) =>{
        return CleverTap.event.push("DeleteAccount", {
            "profile": profile, 
            "type": logintype,
            "status": status, 
            "status description": statusDesc
        })
    }

    const CT_AddNumber = (BMobile, nickName, status, statusDesc) =>{
        return CleverTap.event.push("AddNumber", {
            "BMobile Number": BMobile, 
            "Nickname": nickName, 
            "Status": status, 
            "status description": statusDesc, 
        })
    }

    const CT_ProductViewed = (item, type) =>{
        return CleverTap.event.push("ProductViewed", {
            "name": getItemName(item, type) ?? "", 
            "price": getPrice(item, type) ?? "",
            "sub category": "Data", 
            "category": getCategory(item, type) ?? "",
        })
    }

    const CT_NojoomTransferPoints = (type, B_party, name, status, statusDesc) =>{
        return CleverTap.event.push("NojoomTransferPoints",{
            "Mobile Number": msisdn, 
            "Transfer Type":type,
            "B party Mobile Number":B_party,
            "Partner_Donate Name": name, // not yet sent
            "Status":status,
            "Status Description":statusDesc,
            "Channel": "WEB"
        })
    }

    const CT_Pay = (serviceType, paymentType, toatalAmount, mobileNumberList, status) =>{
        return CleverTap.event.push("Pay", {
            "ServiceType": serviceType,
            "Mobile Number": msisdn,
            "Payment Type": paymentType,
            "Payment Amount": toatalAmount,
            "Paid Mobile Number": mobileNumberList,
            "PaymentDetails": "", //clarification required
            "Status": status,
            "Channel": "WEB",
            "Login Type": logintype
        })
    }

    const CT_NojoomProductRedemption = (type, points, product, status, statusDesc) =>{
        return CleverTap.event.push("NojoomProductRedemption", {
            "Mobile Number": msisdn,
            "Redemption Type": type,
            "Redemption Product": product,
            "Points": points,
            "Status": status,
            "Status Description": statusDesc,
            "Channel": "WEB"
        })
    }

    const CT_BillPayment = (paymentType, amount, B_party, paymentDetails, status) =>{
        return CleverTap.event.push("BillPayment", {
            "Mobile Number": msisdn,
            "Payment Type": paymentType,
            "Payment Amount": amount,
            "Paid Mobile Number": B_party,
            "PaymentDetails": paymentDetails,
            "Status": status,
            "Channel": "Web",
            "Login Type": logintype
        })
    }

    const CT_BuyService = (status, statusDesc, item, type ) =>{
        return CleverTap.event.push("BuyService", {
            "Mobile Number": msisdn,
            "Service Category": item?.servicetype ?? "",
            "Service Subcategory": item?.subcategory ?? "",
            "Offer ID": getId(item, type) ?? "",
            "Offer Name": getItemName(item, type) ?? "",
            "Action Type": "Active",
            "Offer type": type,
            "Price": getPrice(item, type) ?? "",
            "Status": status, 
            "Status Description": statusDesc,
            "Channel": "WEB",
            "Login Type": logintype
        })
    }

    const CT_NojoomProductViewed = (productViewedStatus, status, statusDesc) =>{
        return CleverTap.event.push("NojoomProductViewed", {
            "Mobile Number": msisdn,
            "Product Viewed": productViewedStatus,//
            "Status": status,
            "Status Description": statusDesc,
            "Channel": "WEB",
            "Login Type": logintype
        })
    }

    const CT_NojoomBuyPoints = (points, type, statusDesc, primaryNumber) =>{
        return CleverTap.event.push("NojoomBuyPoints", {
            "Mobile Number": msisdn,
            "Points": points,
            "Payment Type": type,
            "Status Description": statusDesc,
            "Channel": "WEB",
            "Nojoom Primary Number": primaryNumber
        })
    }
    const CT_TechnicalSupport = (category, subCategory, status, statusDesc) =>{
        return CleverTap.event.push("TechnicalSupport", {
            "Mobile Number": msisdn,
            "Category": category,
            "Sub Category": subCategory,
            "Status": status,
            "Status Description":statusDesc,
            "Channel": "WEB"
        })
    }

    const CT_ViewBill = (viewBill, status, statusDesc) =>{
        return CleverTap.event.push("ViewBill", {
            "Mobile Number": msisdn,
            "Authenitcated": getItemOfSessionStorage(AUTH_KEY) ? "YES": "NO",
            "ViewBill": viewBill,
            "Status": status,
            "Status Description": statusDesc
        })
    }

    const CT_Search = (searchKeyword, status, offerTitlesList) =>{
        const statusDesc = `${offerTitlesList?.length} ${offerTitlesList?.length == 1 ? "item" : "items"} found`;
        if(searchKeyword?.length >=3){
            return CleverTap.event.push("Search", {
                "Mobile number": msisdn, 
                "ScreenName": data.pagename, 
                "SearchKeyword": searchKeyword,
                "Status": status, 
                "Status Description": statusDesc, 
                "resultoffers"	: JSON.stringify(offerTitlesList)
            })
        }
    }

    const CT_Filter = (categories, price, resultOffers) =>{
        return CleverTap.event.push("Filter", {
            "Mobile number": msisdn, 
            "screen name": data.pagename, 
            "category": JSON.stringify(categories),
            "price": JSON.stringify(price), 
            "resultoffers": JSON.stringify(resultOffers)
        })
    }

    const CT_Reward = () =>{
        return CleverTap.event.push("Reward", {
            "Mobile Number": msisdn,
            "LoginType": logintype,
            "RewardName": "",
            "RewardEligibility": "",
            "Action": "",
            "RewardProduct": "",
            "Status": "",
            "Status Description": "",
            "Channel": "WEB"
        })
    }

    const CT_PostpaidCVM = (serviceType, category, subcategory, price, details, status, statusdesc) =>{
        return CleverTap.event.push("PostpaidCVM", {
            "Mobile Number": msisdn,
            "Offer type": serviceType,
            "Offer Category": category,
            "Offer Subcategory": subcategory,
            "Price": price,
            "Offer details": details,
            "Status":status,
            "Status Description": statusdesc,
            "Offer availability": 'Offer available'
        })
    }

    const CT_XpressProfit = (msisdn_b, amount, status, statusdesription) =>{
        return CleverTap.event.push("Xpress Profit", {
            'Mobile Number': msisdn,
            'B Party':msisdn_b,
            "Amount": amount,
            "status": status,
            'Status Description': statusdesription,
            'Login Type': logintype,
            "Type": "C2C",
      });
    }

    const CT_OfferPurchase = (status,statusDesc, paymentType, amount, category, subCategory, id, name )=>{
        return CleverTap.event.push("OfferPurchase", {
            "Status": status,
            "Login Type": logintype,
            "Mobile Number": msisdn,
            "Payment Type": paymentType,
            "Offer Name": name,
            "Offer Category": category,
            "Offer ID": id,
            "Price": amount,
            "Offer Subcategory": subCategory,
            "Status Description": statusDesc,
            "PurchaseType": "SELF"
        })
    }

     return {
        CT_ScreenView,
        CT_SignUp,
        CT_OtpVerification,
        CT_BalanceTransfer,
        CT_Logout,
        CT_MoreDetails,
        CT_ChangeLanguage,
        CT_ChangeNumber,
        CT_UserProfilePlan,
        CT_InternetTransfer,
        CT_DeleteAccount,
        CT_AddNumber, 
        CT_ProductViewed,
        CT_NojoomTransferPoints,
        CT_Pay,
        CT_BillPayment,
        CT_BuyService, 
        CT_NojoomProductViewed,
        CT_NojoomProductRedemption,
        CT_NojoomBuyPoints,
        CT_TechnicalSupport,
        CT_ViewBill, 
        CT_Search, 
        CT_Filter, 
        CT_Reward,
        CT_PostpaidCVM,
        CT_XpressProfit,
        CT_OfferPurchase
    }
}
